import apiClient from "../../core/apiClient";
import { InsuranceData } from "../../interfaces/DTO/insurance_data/InsuranceData";
import { BaseService } from "../BaseService";

const API_URL = "/insurance-data";

export interface InsurancePolicyGroup {
  contact_id: number;
  reported_period: string;
  handler_code: string;
  policy_numbers: string[];
}

export interface CoverageEmailResult {
  sent: number;
  failed: Array<{ handler_code: string; reason: string }>;
}

interface UploadHarHabituachResponse {
  message: string;
  success: number;
  failed: Array<[string, string]>;
  failed_count: number;
}

class InsuranceDataService extends BaseService<InsuranceData> {
  constructor() {
    super(API_URL);
  }

  async getByContactId(contactId: number): Promise<InsuranceData[]> {
    if (!contactId) return [];
    const res = await apiClient.get<InsuranceData[]>(`${this.baseUrl}/by-contact?contact_id=${contactId}`);
    return res.data;
  }

  async getByContactIds(contactIds: number[]): Promise<InsuranceData[]> {
    if (!contactIds.length) return [];
    const res = await apiClient.get<InsuranceData[]>(`${this.baseUrl}/by-contacts?contact_ids=${contactIds.join(",")}`);
    return res.data;
  }

  async getGroupedByContacts(contactIds: number[]): Promise<InsurancePolicyGroup[]> {
    if (!contactIds.length) return [];
    const res = await apiClient.get<InsurancePolicyGroup[]>(
      `${this.baseUrl}/grouped-by-contacts?contact_ids=${contactIds.join(",")}`
    );
    return res.data;
  }

  async sendCoverageEmails(contactIds: number[]): Promise<CoverageEmailResult> {
    const res = await apiClient.post<CoverageEmailResult>(
      `${this.baseUrl}/send-coverage-emails?contact_ids=${contactIds.join(",")}`
    );
    return res.data;
  }

  async sendSingleCoverageEmail(contactId: number, handlerCode: string, recipient: string): Promise<CoverageEmailResult> {
    const res = await apiClient.post<CoverageEmailResult>(
      `${this.baseUrl}/send-coverage-email?contact_id=${contactId}&handler_code=${encodeURIComponent(handlerCode)}&recipient=${encodeURIComponent(recipient)}`
    );
    return res.data;
  }

  async uploadHarHabituachFile(file: File): Promise<UploadHarHabituachResponse> {
    const formData = new FormData();
    formData.append("file", file);

    const res = await apiClient.post<UploadHarHabituachResponse>(
      `${this.baseUrl}/upload-har-habituach`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return res.data;
  }
}

export const insuranceDataService = new InsuranceDataService();